import {
  CHANGE_USER_PREFERENCES,
  LOGIN_USER,
  SELECT_PROFILE,
  SET_TIME_TO_COUNT,
  UPDATE_USER,
} from "./actions.types";

export const loginUser = (user: any) => {
  return {
    type: LOGIN_USER,
    user,
  };
};

export const selectProfile = (profile: any) => {
  return {
    type: SELECT_PROFILE,
    profile,
  };
};

export const updateUser = (user: any) => {
  return {
    type: UPDATE_USER,
    user,
  };
};

export const changeUserPreferences = (preferences: any) => {
  return {
    type: CHANGE_USER_PREFERENCES,
    preferences,
  };
};

export const setTimeToCount = (timeToCount: any) => {
  return {
    type: SET_TIME_TO_COUNT,
    timeToCount,
  };
};
